import { NotificationBell } from "@/components/notification/notification-drawer";
import { AnnouncementMegaPhone } from "@/components/announcement/announcement-drawer";
import { SplitScreenToggle } from "../split-screen/split-screen-toggle";
import { GlobalSearch } from "./global-search";
import { PlanHubWidget } from "./plan-hub";
import { AiTimeNudge } from "./widgets/AiTimeNudge";
import { TimeSavedWidget } from "./widgets/TimeSavedWidget";
import { ProfileMenu } from "./ProfileMenu";
import { useSubscriptionSummary } from "./useSubscriptionSummary";
import { LanguageSwitcher } from "@/components/common/LanguageSwitcher";
import { ChatHeaderButton } from "./ChatHeaderButton";

/** Right-hand cluster of the top bar: search, AI widgets, alerts, profile. */
export const HeaderActions = () => {
  const {
    isAdmin,
    hasSubscription,
    hasSubscriptionAccess,
    totalTimeSavedMinutes,
  } = useSubscriptionSummary();

  return (
    <div className="flex gap-2 ps-3 md:ps-0">
      <div className="flex items-center gap-2 md:gap-3">
        <div className="hidden md:block">
          <GlobalSearch />
        </div>
        <LanguageSwitcher />
        {/* Maya copilot now mounts app-level as a draggable FAB (see Layout) */}

        {/* AI nudge — subscription exists but no AI usage yet */}
        {hasSubscription && totalTimeSavedMinutes === 0 && (
          <AiTimeNudge hasSubscriptionAccess={hasSubscriptionAccess} />
        )}

        {/* Time saved — any subscribed user with usage */}
        {hasSubscription && totalTimeSavedMinutes > 0 && (
          <TimeSavedWidget
            minutes={totalTimeSavedMinutes}
            hasSubscriptionAccess={hasSubscriptionAccess}
          />
        )}

        {/* Plan hub — seats + AI tokens usage, hover preview, upgrade actions */}
        {isAdmin && hasSubscription && hasSubscriptionAccess && (
          <PlanHubWidget className="hidden md:inline-flex" />
        )}

        <SplitScreenToggle />
        <AnnouncementMegaPhone />
        <ChatHeaderButton />
        <NotificationBell />
        <hr className="bg-black/10 w-0.5 h-9" />
        <ProfileMenu />
      </div>
    </div>
  );
};
